export default __webpack_public_path__ + "static/media/problema-08.57f5b6db.webp";